import moment from "moment";

export default {
  data: function() {
    return {
      rules: {
        required: (value) => (!!value || value === 0) || "Required.",
        requiredNoBlanks: value => {
          return ((!!value || value === 0) && String(value).match(/^(?!\s*$).+/g) != null) || "Required.";
        },
        requiredArray: value => {
          return ((!!value || Array.isArray(value) && value.length !== 0)) || "Required.";
        },
        numeric: (value) => {
          if (value && value.length > 0 && isNaN(value)) {
            return "Must be a number";
          } else {
            return true;
          }
        },
        integer: (value) => {
          if (value && value.length > 0) {
            if (isNaN(value)) {
              return "Must be a number";
            } else if (!Number.isInteger(parseFloat(value))) {
              return "Must be an integer";
            }
          }
          return true;
        },
        positiveNumber: (value) => {
          if (value && value.length > 0) {
            if (isNaN(value)) {
              return "Must be a number";
            } else if (parseFloat(value) <= 0) {
              return "Must be greater than 0";
            }
          }
          return true;
        },
        nonNegativeNumber: (value) => {
          if (value && value.length > 0) {
            if (isNaN(value)) {
              return "Must be a number";
            } else if (parseFloat(value) < 0) {
              return "Cannot be negative";
            }
          }
          return true;
        },
        numberInRange: (value, start, end) => {
          if (value && value.length > 0) {
            if (isNaN(value)) {
              return "Must be a number";
            } else if (parseFloat(value) < parseFloat(start)) {
              return "Cannot be less than " + start;
            } else if (parseFloat(value) > end) {
              return "Cannot be more than " + end;
            }
          }
          return true;
        },
        currency: (value) => {
          const pattern = /^$/;
          if (value && value.length > 0) {
            if (isNaN(value)) {
              return "Must be a number";
            }
            if ((parseFloat(value)+'').length > parseFloat(value).toFixed(2).length) {
              return "Number format invalid"
            }
          }
          return true;
        },
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          if (value && value.length > 0 && !pattern.test(value)) {
            return "Invalid e-mail.";
          } else {
            return true;
          }
        },
        validEndDate: (startDate, endDate) => {
          return startDate <= endDate || "Invalid Date.";
        },
        validStartTime: (startTime, startDate, endTime, endDate) => {
          let currentDate = moment(new Date()).format("YYYY-MM-DD");
          let currentTime = moment(new Date()).format("HH:mm");
          if (currentDate === startDate) {
            return currentTime <= startTime || "Invalid Time.";
          }
          return true;
        },
        validEndTime: (startTime, startDate, endTime, endDate) => {
          if (startDate === endDate) {
            return startTime < endTime || "Invalid Time.";
          } else if (startDate > endDate) {
            return "Invalid Time.";
          }
          return true;
        },
        url: (value) => {
          if (
            value &&
            value.length > 0 &&
            !value.match(
              /^((http[s]?|ftp):\/)?\/?([^:\/\s]+)((\/\w+)*\/)([\w\-\.]+[^#?\s]+)(.*)?(#[\w\-]+)?$/
            )
          ) {
            return "Invalid URL";
          } else {
            return true;
          }
        },
        hoursMinutes: (value) => {
          if (value && value.length > 0) {
            if (!value.match(/^\d?$/) && !value.match(/^\d?:[0-5]\d$/)) {
              return "Invalid time format";
            } else {
              return true;
            }
          } else {
            return true;
          }
        }
      },
    }
  },
};
